export async function share(hex: string) {
  const link = `${window.location.protocol}//${window.location.host}/coupon?id=${hex}`;
  navigator.share({
    title: 'Sipps Coffee',
    url: link,
  });
}

export async function validate(hex: string) {
  return await fetch(`/api/coupon/${hex}/validate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  })
    .then((r) => r.json())
    .then((json: { state: string }) => {
      if (json.state !== 'AUTHORIZED') {
        window.location.assign(`/failed-payment`);
      }
    });
}
